import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

const SubMenu = ({ item, isActive, onSubMenuClick, onMainClick }) => {
  const [subMenuActive, setSubMenuActive] = useState(false);
  const handleSubMenuClick = () => {
    onSubMenuClick(item.id);
    setSubMenuActive(!subMenuActive);
  };

  const hasSubmenu2 = item.submenuItems1 && item.submenuItems1.length > 0;
  const mainMenuClass2 = hasSubmenu2 ? 'nav-link with-sub2' : 'sub-link2';
  const isNavLink2 = !hasSubmenu2;

  return (
    <ul key={item.id } className={`nav-item ${isActive ? 'show active' : ''}`} >

      {isNavLink2 ? (
        <NavLink
          to={item.link}
          className={`sub-link2`}
          onClick={handleSubMenuClick}
        >
          {item.icon}
          <span>{item.label}</span>
        </NavLink>
      ) : (
        <a href="#" className={isActive ? 'nav-link with-sub' : 'nav-link2 with-sub2'} onClick={(e) => { e.preventDefault(); handleSubMenuClick(); }}>
          {item.icon}
          <span>{item.label}</span>
        </a>
      )}

      {isActive && hasSubmenu2 && (
        <ul className={`nav-sub ${subMenuActive ? 'active show' : ''}`}>
          {item.submenuItems1.map((subItem) => (
            <li>
            <NavLink
              to={subItem.link}
              key={subItem.id}
              className={`sub-link2 ${subItem.submenuItems1 && subItem.submenuItems1.length > 0 ? 'active' : ''}`}
            >
              {subItem.label}
            </NavLink>
            </li>
          ))}
        </ul>
      )}
    </ul>
  );
};

const SideMenu = ({ icon, link, label, submenuItems, isActive, onMainClick, dash }) => {
  const [activeSubMenuId, setActiveSubMenuId] = useState(null);
  const hasSubmenu = submenuItems && submenuItems.length > 0;

  const isNavLink = !hasSubmenu;

  const mainMenuClass = hasSubmenu ? 'nav-link with-sub' : 'nav-link';

  const [subMenuActive, setSubMenuActive] = useState(false);
  const handleSubMenuClick = (subMenuId) => {
    setActiveSubMenuId(subMenuId);
    setSubMenuActive(!subMenuActive);
  };

  return (
    <li className={`nav-item ${isActive ? 'show active' : ''}`}>
      {isNavLink ? (
        <NavLink to={link} className={mainMenuClass} onClick={onMainClick}>
          {icon}
          <span>{label}</span>
        </NavLink>
      ) : (
        <a href="#" className={mainMenuClass} onClick={(e) => { e.preventDefault(); onMainClick(); }}>
          {icon}
          <span>{label}</span>
        </a>
      )}

      {isActive && hasSubmenu && (
        <div className={`nav-sub ${subMenuActive ? 'show' : ''}`}>
          {submenuItems.map((item, subIndex) => (
            <SubMenu
              key={item.id}
              item={item}
              isActive={activeSubMenuId === item.id}
              onSubMenuClick={handleSubMenuClick}
            />
          ))}
        </div>
      )}
    </li>
  );
};

export default SideMenu;
